<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row class="flex">
      <el-input
        size="small"
        v-model="searchFrom.taskName"
        class="w-200px mr-10px"
        placeholder="任务名称"
        clearable
      ></el-input>
      <el-input
        size="small"
        v-model="searchFrom.dataSourceName"
        class="w-200px mr-10px"
        placeholder="数据源名称"
        clearable
      ></el-input>
      <el-input
        size="small"
        v-model="searchFrom.dataServer"
        class="w-200px mr-10px"
        placeholder="主机名/IP地址"
        clearable
      ></el-input>
      <el-select
        size="small"
        v-model="searchFrom.sourceType"
        class="w-200px mr-10px"
        placeholder="类型"
        clearable
      >
        <el-option
          v-for="(item, index) in sourceTypeList"
          :key="index"
          :value="item.item1"
          :label="item.item2"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        v-model="searchFrom.dataBase"
        class="w-200px mr-10px"
        placeholder="数据库名称"
        clearable
      ></el-input>
      <el-input
        size="small"
        v-model="searchFrom.port"
        class="w-200px mr-10px"
        placeholder="端口"
        clearable
      ></el-input>
      <el-date-picker
        type="date"
        size="small"
        v-model="searchFrom.startDate"
        class="w-200px mr-10px"
        placeholder="开始日期"
        clearable
        value-format="yyyy-MM-dd HH:mm:ss"
      ></el-date-picker>
      <el-date-picker
        type="date"
        size="small"
        v-model="searchFrom.endDate"
        class="w-200px mr-10px"
        placeholder="结束日期"
        clearable
        value-format="yyyy-MM-dd HH:mm:ss"
      ></el-date-picker>
    </el-row>
    <el-row class="mt-10px flex">
      <el-select
        size="small"
        v-model="searchFrom.connectState"
        class="w-200px mr-10px"
        placeholder="连接状态"
        clearable
      >
        <el-option :value="0" label="连接成功"></el-option>
        <el-option :value="1" label="连接失败"></el-option>
        <el-option :value="2" label="测试连接中"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="sizeChange">搜索</el-button>
      <el-button size="small" @click="resetSearchQuery">重置</el-button>
      <el-button
        type="primary"
        size="small"
        @click="addMetadata('新增')"
        :disabled="!$hasAccess('create')"
        >新增</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="testConnection()"
        :disabled="!$hasAccess('testConnection')"
        :lodaing="testLoading"
        >测试连接</el-button
      >
      <el-button
        type="danger"
        size="small"
        @click="deleteMetadata(1)"
        :lodaing="deleteLoading"
        :disabled="!$hasAccess('delete')"
        >删除</el-button
      >
      <el-button
        size="small"
        @click="exportMetaList"
        :loading="exportLoading"
        :disabled="!$hasAccess('export')"
        >导出</el-button
      >
      <el-button size="small" @click="importFile" :disabled="!$hasAccess('import')">导入</el-button>
    </el-row>
    <el-table
      :data="tableList"
      height="calc(100% - 152px)"
      class="mt-20px"
      border
      v-loading="tableLoading"
      :row-key="(record) => record.id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column prop="taskName" label="任务名称" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="dataSourceName"
        label="数据源名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="sourceType" label="类型" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="dataServer"
        label="主机名/IP地址"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="dataBase" label="数据库名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="tableName" label="数据表名称" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="destTableCode"
        label="目标表代码"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="destTableName"
        label="目标表名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="collectNumbe" label="采集数量" show-overflow-tooltip></el-table-column>
      <el-table-column prop="connectStateStr" label="连接状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <!-- 【0：连接成功】绿色 【1：连接失败】红色 【2：测试连接中】灰色-->
          <el-tag type="success" size="small" v-if="scope.row.connectState === 0">{{
            scope.row.connectStateStr
          }}</el-tag>
          <el-tag type="danger" size="small" v-else-if="scope.row.connectState === 1">{{
            scope.row.connectStateStr
          }}</el-tag>
          <el-tag size="small" type="info" v-else-if="scope.row.connectState === 2">{{
            scope.row.connectStateStr
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="{ row }">
          <el-button
            :disabled="!$hasAccess('read')"
            @click.stop="addMetadata('查看', row)"
            size="mini"
            >{{ $t('view') }}</el-button
          >
          <el-button
            :disabled="!$hasAccess('update')"
            @click.stop="addMetadata('编辑', row)"
            size="mini"
            >{{ $t('edit') }}</el-button
          >
          <el-button
            :disabled="!$hasAccess('delete')"
            @click.stop="deleteMetadata(2, row)"
            size="mini"
            >{{ $t('delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tr">
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.recordCount"
      ></el-pagination>
    </div>
    <collectionCreate
      v-if="isShowCreateDialog"
      :visible.sync="isShowCreateDialog"
      :dialogTitle="createDialogTitle"
      :operateMetadata="operateMetadata"
      @success="getTableDataList"
    ></collectionCreate>
    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getTableDataList"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import MetadataManageService from '@/services/MetadataManageService'
import fnMixin from '@/assets/js/fnMixins'

const collectionCreate = () => {
  return import('./components/collectionCreate')
}

export default {
  name: 'collectionManage',
  components: {
    collectionCreate,
  },
  mixins: [fnMixin],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      searchFrom: {
        taskName: '', // 任务名称
        dataSourceName: '', // 数据源名称
        dataServer: '', // ip
        sourceType: '', // 类型
        dataBase: '', // 数据库名称
        port: '', // 端口
        startDate: '', // 开始日期
        endDate: '', // 结束日期
        connectState: '', // 连接状态
      },
      sourceTypeList: [], // 类型下拉框
      tableList: [], // 列表数据
      selectedList: [], // 列表选中项
      page: {
        pageNo: 1,
        pageSize: 15,
        recordCount: 0,
      }, // 分页数据
      isShowCreateDialog: false, // 是否显示新增弹窗
      createDialogTitle: '', // 新增弹窗title
      operateMetadata: null, // 操作项数据(新增or编辑or查看)
      exportLoading: false, // 导出按钮的loading
      tableLoading: false, // 列表的loading
      deleteLoading: false, // 删除按钮的lodaing
      testLoading: false, // 测试连接的loading
    }
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await MetadataManageService.downloadTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '元数据采集导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await MetadataManageService.import(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '元数据采集导入明细.xlsx',
          data: res,
        })
        this.getTableDataList()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 获取类型下拉框数据
    async getDbTypes() {
      const res = await MetadataManageService.getDbTypes()
      if (res && res.code === 0) {
        this.sourceTypeList = res.data
      }
    },
    // 批量测试连接
    async testConnection() {
      if (this.selectedList.length > 0) {
        const ids = _.map(this.selectedList, (item) => {
          return item.id
        })
        this.testLoading = true
        const res = await MetadataManageService.testConnection(ids)
        this.testLoading = false
        if (res && res.code === 0) {
          this.$message.success('测试连接成功')
          this.getTableDataList()
          this.selectedList = []
        }
      } else {
        this.$message.warning('请选择要测试连接的数据')
      }
    },
    /**
     * @description 搜索
     */
    async getTableDataList() {
      this.tableLoading = true
      const payload = {
        task_name: {
          $text: this.searchFrom.taskName,
        },
        data_source_name: {
          $text: this.searchFrom.dataSourceName,
        },
        data_server: {
          $text: this.searchFrom.dataServer,
        },
        db_type: this.searchFrom.sourceType,
        data_base: {
          $text: this.searchFrom.dataBase,
        },
        port: {
          $text: this.searchFrom.port,
        },
        pageno: this.page.pageNo,
        pagesize: this.page.pageSize,
        connect_state: this.searchFrom.connectState,
      }
      payload['created_time[$gt]'] = this.searchFrom.startDate
      payload['created_time[$lt]'] = this.searchFrom.endDate
      const res = await MetadataManageService.getListOrDetail(payload)
      this.tableLoading = false
      if (res && res.data && res.code === 0) {
        this.tableList = res.data
        this.page.recordCount = res.page.recordCount
      }
    },

    /**
     * @description 重置
     */
    resetSearchQuery() {
      this.searchFrom = {
        taskName: '',
        dataSourceName: '',
        dataServer: '',
        sourceType: '',
        dataBase: '',
        port: '',
        startDate: '',
        endDate: '',
      }
      this.sizeChange()
    },

    /**
     * @description 新增or编辑or查看
     * @param {String} title: 标题名称
     * @param {Object or null} metadataItem：单条元数据
     */
    addMetadata(title, metadataItem = null) {
      this.createDialogTitle = title
      if (metadataItem) {
        this.operateMetadata = { ...metadataItem }
      }
      this.isShowCreateDialog = true
    },

    /**
     * @description 删除
     * @param {Number} type：删除的是单条数据还是多条数据
     * @param {Object or undefined} metadata：操作列表删除按钮选中的数据
     */
    deleteMetadata(type, metadata) {
      let ids = [] // 删除项id
      if (type === 1) {
        if (!this.selectedList.length) {
          this.$message.warning('请先选择要删除的数据')
          return
        }
        // 删除选中数据操作
        ids = _.map(this.selectedList, (item) => {
          return item.id
        })
        this.deleteLoading = true
      } else {
        // 列表按钮删除操作
        ids = [metadata.id]
      }
      const tipStr = type === 1 ? '是否确定要删除所选数据' : '是否确定要删除该条数据'
      this.$confirm(tipStr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await MetadataManageService.deleteMatedata({
            data: ids,
          })
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.deleteLoading = false
            if (this.tableList.length === 1 && this.page.pageNo > 1) {
              this.page.pageNo -= 1
              this.getTableDataList()
              return
            }
            this.getTableDataList()
          }
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },

    /**
     * @description 导出
     */
    async exportMetaList() {
      this.exportLoading = true
      const res = await MetadataManageService.exportMatedata({
        urlParam: `data_source_name[$text]=${this.searchFrom.dataSourceName}&task_name[$text]=${this.searchFrom.taskName}&data_server[$text]=${this.searchFrom.dataServer}&data_base[$text]=${this.searchFrom.dataBase}&port[$text]=${this.searchFrom.port}&created_time[$gt]=${this.searchFrom.startDate}&created_time[$lt]=${this.searchFrom.endDate}&Type=${this.searchFrom.sourceType}`,
        downloadType: 0, // 0: url, 1: 文件流
        ids: _.map(this.selectedList, 'id'),
      })
      this.exportLoading = false
      if (res) {
        this.downLoadExcel('元数据采集导出结果.xlsx', res)
      }
    },

    /**
     * @description 跨页多选
     * @param {Array} selectedList
     */
    handleSelectionChange(selectedList) {
      this.selectedList = selectedList
    },

    sizeChange() {
      this.page.pageNo = 1
      this.getTableDataList()
    },

    currentChange() {
      this.getTableDataList()
    },
  },

  async created() {
    await this.getDbTypes()
    this.getTableDataList()
  },
}
</script>
